import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { ContractModalSource } from '#src/app/pages/ambassadors/landing/pageContext';
import { useAmbassadorsPageState } from '#src/app/pages/ambassadors/landing/pageContext';

/**
 * Opens the contract modal and tracks the open event, tagged with the CTA the user came from.
 *
 * Every CTA on the page (hero, footer, header) does exactly this and differs only by `source`,
 * so the behaviour lives here rather than being repeated in each component's own hook. The
 * component hooks stay in place as thin wrappers to keep the one-hook-per-component convention.
 */
export function useContractModalCta(source: ContractModalSource): () => void {
	const [, { openContractModal }] = useAmbassadorsPageState();
	const track = useTracking();

	return useCallback(() => {
		openContractModal(source);
		void track('ambassadors_contract_modal_open', { source_location: source });
	}, [openContractModal, track, source]);
}
